export default "__VITE_ASSET__D9ukJ5K$__"